import { render, staticRenderFns } from "./axis.vue?vue&type=template&id=31c86333&"
import script from "./axis.vue?vue&type=script&lang=js&"
export * from "./axis.vue?vue&type=script&lang=js&"
import style0 from "./axis.vue?vue&type=style&index=0&id=31c86333&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports